module.exports = __webpack_public_path__ + "img/VC.df73ed44.svg";